import { PadLeftZero } from "./number";

let moment = require("moment");

export function GetDateString(date) {
  let y = date.getFullYear().toString();
  let m = PadLeftZero(date.getMonth() + 1);
  let d = PadLeftZero(date.getDate());
  return y + "-" + m + "-" + d;
}

export function GetVerboseDateStringFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("MMMM DD, YYYY");
}

export function GetDateStringFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("YYYY-MM-DD");
}

export function GetDateTime(timestamp = new Date()) {
  return moment(timestamp).format("MMMM D, YYYY h:mm A");
}
export function GetTime(timestamp = new Date()) {
  return moment(timestamp).format("LT");
}

export function GetDateTimeFromDateAsKey() {
  return moment(new Date()).format("YYYY MM DD hhmmss");
}

export function GetDate(date) {
  return moment(new Date(date)).format("MMMM D, YYYY");
}

export function GetDateFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("MMMM D, YYYY");
}
export function GetTimeFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("LT");
}

export function GetDateTimeFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("MMMM D, YYYY h:mm A");
}

export function GetDayDateTimeFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("llll");
}

export function TimeStampToDate(timestamp) {
  return new Date(timestamp.seconds * 1000);
}
